import * as types from "../actions/actionTypes";

const initialState = {
    error: false,
    message: false
};

const errorReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.ERROR_SHOW:
      return { ...state, error:true, message: action.message };
    case types.ERROR_HIDE:
      return { ...state, error:false };
    default:
      return state;
  }
};

export default errorReducer;


// WEBPACK FOOTER //
// ./src/reducers/errorReducer.js